import React, { useState } from "react";

const ContentTab = ({ handleLayoutChange, selectedLayout,updatePricingTableTabData,pricingTableTabData }) => {
    const [multipleTableMode, setMultipleTableMode] = useState(Number(pricingTableTabData.is_multiple_table_mode));
    const [defaultTableType, setDefaultTableType] = useState(pricingTableTabData.default_table_type);
    const [defaultTableTypeDropdownOpen, setDefaultTableTypeDropdownOpen] = useState(false);
    const [widgetTitle, setWidgetTitle] = useState(Number(pricingTableTabData.is_widget_title));
    const [title, setTitle] = useState(pricingTableTabData.title);
    const [caption, setCaption] = useState(pricingTableTabData.caption);
    const [languageType, setLanguageType] = useState(pricingTableTabData.language_type);
    const [languageTypeDropdownOpen, setLanguageTypeDropdownOpen] = useState(false);

    //Handlers Is Multiple Table Mode On Change
    const handleMultipleTableModeChange = (e) => {
        const checked = e.target.checked;
        setMultipleTableMode(checked);
        updatePricingTableTabData("is_multiple_table_mode", checked); 
    };

    // Handlers Default Table Type on Change
    const handleDefaultTableTypeChange = (type) => {
        setDefaultTableType(type);
        updatePricingTableTabData(prev => ({
            ...prev,
            default_table_type: type
        }));
        setDefaultTableTypeDropdownOpen(false);
    };

    //Handlers Is Widge Title On Change
    const handleWidgetTitleChange = (e) => {
        const checked = e.target.checked;
        setWidgetTitle(checked);
        updatePricingTableTabData("is_widget_title", checked); 
    };

    // Handlers Title On Change
    const handleTitleChange = (event) => {
        const value = event.target.value;
        setTitle(value);
        updatePricingTableTabData("title", value);
    };

    // Handlers Caption On Change
    const handleCaptionChange = (event) => {
        const value = event.target.value;
        setCaption(value);
        updatePricingTableTabData("caption", value);
    };

    // Handlers Language Type on Change
    const handleLanguageTypeChange = (type) => {
        setLanguageType(type);
        updatePricingTableTabData(prev => ({
            ...prev,
            language_type: type
        }));
        setLanguageTypeDropdownOpen(false);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Content</span>
            {Number(pricingTableTabData.is_multiple_table_mode) === 1 && (
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                        <label>Tables</label>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row"><span>Billed Monthly</span>
                        </div>
                    </div>
                    <div className="box-header-row bubble-text">
                        <span>Billed Yearly</span>
                    </div>
                </div>
            )}
            {Number(pricingTableTabData.is_multiple_table_mode) === 0 && (
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                        <label>Columns</label>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <ul>
                                <li><img src={`${process.env.PUBLIC_URL}/pricing-table/templates/pricing_basic.png`} alt="pricing_basic" /></li>
                                <li>Basic</li>
                                <li>Ideal for a small website/blog</li>
                            </ul>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <ul>
                                <li><img src={`${process.env.PUBLIC_URL}/pricing-table/templates/pricing_standard.png`} alt="pricing_standard" /></li>
                                <li>Standard</li>
                                <li>Perfect for a corporate</li>
                            </ul>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <ul>
                                <li><img src={`${process.env.PUBLIC_URL}/pricing-table/templates/pricing_premium.png`} alt="pricing_premium" /></li>
                                <li>Premium</li>
                                <li>The best for high traffic websites</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            <div className="side-baar-box-header">
                <div className="side-baar-box-header">
                    <div className="box-header-row"><span>Multiple Tables Mode </span>
                        <div className="form-group">
                            <input id="open_is_multiple_table_mode" className="chkbx-toggle" type="checkbox" checked={multipleTableMode} onChange={handleMultipleTableModeChange} />
                            <label for="open_is_multiple_table_mode"></label> 
                        </div>
                    </div>
                </div>
                {Number(pricingTableTabData.is_multiple_table_mode) === 1 && (
                    <div className="box-header-row">
                        <span>Default Table</span>
                        <div className="color-pikr-box" onClick={() => setDefaultTableTypeDropdownOpen(!defaultTableTypeDropdownOpen)}>
                            <em>{defaultTableType}</em>
                            {defaultTableTypeDropdownOpen && (
                                <ul className="dropdown-list">
                                    {["Billed Monthly","Billed Yearly"].map((type) => (
                                        <li key={type} onClick={() => handleDefaultTableTypeChange(type)}>
                                            {type}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                )}
                <p>
                This mode allows to create multiple tables and toggle between them. Use this mode if you need to switch between different billing periods, offer options etc.
                </p>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row"><span>Widget Title</span>
                    <div className="form-group">
                        <input id="open_is_widget_title" className="chkbx-toggle" type="checkbox" checked={widgetTitle} onChange={handleWidgetTitleChange} />
                        <label for="open_is_widget_title"></label> 
                    </div>
                </div>
                {Number(pricingTableTabData.is_widget_title) === 1 && (
                <>
                    <div className="box-header-row bubble-text">
                        <label>Title</label>
                        <input type="text" value={title} onChange={handleTitleChange} placeholder="" />
                    </div>
                    <div className="box-header-row">
                        <span>Caption</span>
                        <div className="box-header-row welcome-message">
                            <textarea value={caption} onChange={handleCaptionChange} placeholder="" defaultValue=""></textarea>
                        </div>
                    </div>
                </>
                )} 
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row"><span>Language</span>
                    <div className="color-pikr-box" onClick={() => setLanguageTypeDropdownOpen(!languageTypeDropdownOpen)}>
                        <em>{languageType}</em>
                        {languageTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["English"].map((type) => (
                                    <li key={type} onClick={() => handleLanguageTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentTab;